import React, { useRef } from 'react';
import './landingpage.css';
import { Button } from '@mui/material';
import { paths } from 'src/routes/paths';
import EchoLogo from './echo_logo.svg';
import FooterLogo from './Footer_echo_logo.svg';
import Bg from './background-image2.jpg';

function LandingPage() {
  const bottomRef = useRef<HTMLDivElement>(null);

  return (
    <section style={{ backgroundImage: `url(${Bg})` }} className="Herosection">
      <div className="pdl-80">
        <div className="container-fluid">
          <header className="row align-items-center py-5">
            <div className="col-4">
              <img src={EchoLogo} alt="Logo" className="header_logo" />
            </div>
            <div className="col-8">
              <div className="text-end">
                <Button
                  onClick={() => {
                    if (bottomRef.current) {
                      bottomRef.current.scrollIntoView({ behavior: 'smooth' });
                    }
                  }}
                  variant="contained"
                  sx={{
                    textTransform: 'none',
                    mr: '12px',
                    backgroundColor: '#fff',
                    color: '#000',
                    '&:hover': {
                      backgroundColor: '#f0f0f0', // optional: light gray on hover
                    },
                  }}
                >
                  Contact
                </Button>
                <Button
                  variant="contained"
                  href={paths.auth.karntekadmin.login}
                  sx={{
                    textTransform: 'none',
                    backgroundColor: '#fff',
                    color: '#000',
                    '&:hover': {
                      backgroundColor: '#f0f0f0',
                    },
                  }}
                >
                  Login
                </Button>
              </div>
            </div>
          </header>
          <div className="row">
            <div className="col-12">
              <div className="banner_content text-center">
                <h1> Welcome to Echo. </h1>
                <h3> your building management system </h3>
                <p> please log in to access your portal </p>
              </div>
            </div>
          </div>
        </div>
      </div>
      <section className="content_section">
        <div className="pdl-80">
          <div className="container-fluid">
            <div className="row">
              <div className="col-md-10 offset-md-1">
                <div className="Disc_content">
                  <p>
                    Welcome to the Echo Building Management System, your centralised hub for
                    complete control over your property assets. Our platform offers an unparalleled
                    data management system designed specifically for property and compliance
                    managers, streamlining coordination across multiple buildings with ease.
                  </p>
                  <p>
                    Access all your existing projects, historical maintenance records, and
                    compliance documentation in one secure, intuitive interface. Whether you’re
                    managing one site or numerous locations, our system ensures accuracy,
                    efficiency, and transparency at every level. Stay on top of inspections, monitor
                    ongoing works, and make informed decisions backed by real-time data.
                  </p>
                  <p>Contact us to request a demo.</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
      <section className="footerSection" ref={bottomRef}>
        <div className="pdl-80">
          <div className="container-fluid">
            <div className="row align-items-center">
              <div className="col-md-5">
                <img src={FooterLogo} alt="logo" className="footerLogo" />
              </div>
              <div className="col-md-7">
                <div className="foterRihtContent">
                  {/* <h4> Telephone: 020 7078 4820 </h4> */}
                  <h4>Email: notifications@echo-bms.com</h4>
                  {/* <h4>Address: The Precinct, 1 Finsbury Square, London, EC2A 1AE </h4> */}
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </section>
  );
}

export default LandingPage;
